// test2772
(2772 && 0);
